/* eslint-disable react/jsx-one-expression-per-line */
import React, { useEffect } from 'react'
import { useHookstate } from '@hookstate/core'
import Layout from '~/components/Layout'
import { useLang } from '~/hooks/useLang'
import CrudIndex from '~/components/CrudIndex'

// no types required since results are not rendered here
export default function Index() {
  const { translate } = useLang()

  const name = useHookstate<string | null>(null)
  const forceRefresh = useHookstate(false)

  useEffect(() => {
    document.title = translate('Resources - Dispatch System')
  }, [])



  return (
    <Layout marginLayout={true}>
      <CrudIndex
        model='equipment-group'
        title='Equipment Groups'
        forceOrderColumns={['name']}
        filters={[
          { name: 'name', type: 'name', variable: name },
        ]}
        clearFilters={() => {
          name.set('')
          forceRefresh.set(!forceRefresh.get())
        }}
        searchButton={() => forceRefresh.set(!forceRefresh.get())}
        forceRefresh={forceRefresh.get()}
        disableColumnsFilters
        canView={true}
        showInViewMore={['name', 'created_at']}
        viewTitle='Grupo de equipamento'
      />
    </Layout>
  )
}
